import { sorted } from "helpers";

export const alignGraphSlots = (
  nodes: { id: number; neighbours: number[] }[],
  firstEmptySlot: number,
  order: "neighbours" | "input"
) => {
  const targets = nodes.map((node, index) => ({
    id: node.id,
    slot:
      node.neighbours.length === 0
        ? firstEmptySlot + index
        : node.neighbours.reduce((sum, slot) => sum + slot, 0) /
          node.neighbours.length,
  }));
  const orderedTargets =
    order === "input" ? targets : sorted(targets, (node) => node.slot);
  return new Map(
    orderedTargets.reduce<[number, number][]>(
      (slots, target) => [
        ...slots,
        [target.id, Math.max((slots.at(-1)?.[1] ?? -1) + 1, target.slot)],
      ],
      []
    )
  );
};
